export const ROUTINE_TYPES = {
    BIRTHDAY: '生日推送',
    NEW_BORN: '产假推送',
    ONBOARDING_DAY1: '入职当天推送',
    ONBOARDING_DAY30: '入职30天推送',
    ONBOARDING_DAY60: '入职60天推送',
    SERVICE_ANNIVERSARY_1Y: '服务1周年推送',
    SERVICE_ANNIVERSARY_2Y: '服务2周年推送',
    SERVICE_ANNIVERSARY_3Y: '服务3周年推送',
    SERVICE_ANNIVERSARY_4Y: '服务4周年推送',
    SERVICE_ANNIVERSARY_5Y: '服务5周年推送',
    SERVICE_ANNIVERSARY_6_9Y: '服务6-9周年推送',
    SERVICE_ANNIVERSARY_10Y: '服务10周年推送',
    SERVICE_ANNIVERSARY_15Y: '服务15周年推送',
    SERVICE_ANNIVERSARY_20Y: '服务20周年推送',
    SERVICE_ANNIVERSARY_25Y: '服务25周年推送',
    SERVICE_ANNIVERSARY_30Y: '服务30周年推送',
};

export const SPECIFIC_TYPES = {
    ANNUAL_LEAVE: '年假提醒',
    OFFBOARDING: '离职推送',
    REFERRAL_AWARD: '内推奖励',
    POINTS_REMINDER: '积分提醒',
};

export const SPECIFIC_AUTH_SUFFIXES = {
    ANNUAL_LEAVE: 'annual-leave',
    OFFBOARDING: 'offboarding',
    REFERRAL_AWARD: 'referral-award',
    POINTS_REMINDER: 'points-reminder',
};

// 积分提醒已开放；模板由客户在模板管理中自行创建并启用。
export const POINTS_REMINDER_ENABLED = true;

const isSpecificTypeVisible = type => POINTS_REMINDER_ENABLED || type !== 'POINTS_REMINDER';

/** 当前对用户开放（可见）的特定推送类型。 */
export const getVisibleSpecificTypes = () =>
    Object.keys(SPECIFIC_TYPES).filter(isSpecificTypeVisible);

export const getAuthorizedSpecificTypes = authStore =>
    getVisibleSpecificTypes().filter(type => {
        const authSuffix = SPECIFIC_AUTH_SUFFIXES[type] || type.toLowerCase();
        return (
            authStore.hasAuthorities(
                ['global:hr-specific-push:w', 'app:hr-specific-push:w'],
                'w'
            ) &&
            authStore.hasAuthorities(
                [`global:hr-push-${authSuffix}:w`, `app:hr-push-${authSuffix}:w`],
                'w'
            )
        );
    });

export const DEFAULT_TIME = {
    BIRTHDAY: '08:00',
    NEW_BORN: '11:00',
    ONBOARDING_DAY1: '09:00',
    ONBOARDING_DAY30: '09:30',
    ONBOARDING_DAY60: '12:00',
    SERVICE_ANNIVERSARY_1Y: '09:15',
    SERVICE_ANNIVERSARY_2Y: '09:15',
    SERVICE_ANNIVERSARY_3Y: '09:15',
    SERVICE_ANNIVERSARY_4Y: '09:15',
    SERVICE_ANNIVERSARY_5Y: '09:15',
    SERVICE_ANNIVERSARY_6_9Y: '09:15',
    SERVICE_ANNIVERSARY_10Y: '09:15',
    SERVICE_ANNIVERSARY_15Y: '09:15',
    SERVICE_ANNIVERSARY_20Y: '09:15',
    SERVICE_ANNIVERSARY_25Y: '09:15',
    SERVICE_ANNIVERSARY_30Y: '09:15',
};
